import React, { forwardRef } from 'react'
import '../styles/components/Shimmer.css'

const Shimmer = forwardRef(({ style, className }, ref) => {
  return (
    <div ref={ref} className={`shimmer-container ${className || ''}`} style={style} />
  )
})

export default Shimmer



// WEBPACK FOOTER //
// ./src/components/Shimmer.js